import { Link } from "react-router"
import { useAppState } from "../context";
import type { NavigationType } from "../types/navigation";
import { NAVIGATION_GROUP } from "../constants/navigation";
import EditableTextBlock, { useEditableText } from "../utils/editable-text-block";

export const Footer = () => {
    const [navigation] = useAppState<NavigationType[]>('navigation', []);

    const primaryNavItems = navigation
        .filter(item => item.group === NAVIGATION_GROUP.FOOTER_PRIMARY)
        .sort((a, b) => a.position - b.position);

    const secondaryNavItems = navigation
        .filter(item => item.group === NAVIGATION_GROUP.FOOTER_SECONDARY)
        .sort((a, b) => a.position - b.position);

    const footerEmail = useEditableText('footer-email', 'support@gmail.com', 'Footer email');
    const instagramLink = useEditableText('footer-social-instagram', '#', 'Footer Instagram URL');
    const youtubeLink = useEditableText('footer-social-youtube', '#', 'Footer YouTube URL');
    const facebookLink = useEditableText('footer-social-facebook', '#', 'Footer Facebook URL');

    return <footer className="footer">
        <div className="inside-wrapper">
            <div className="footer__inner">
                <div className="footer__about">
                    <h2 className="footer__title">
                        About Company
                    </h2>
                    <div className="footer__about-text">
                        <p>
                            We&nbsp;believe that each photograph tells a&nbsp;unique story, and our goal is&nbsp;to&nbsp;help you bring these stories
                            to&nbsp;life.
                        </p>
                    </div>
                    <ul className="footer__social social">
                        <li className="social__item">
                            <a href={instagramLink} className="social__link icon-link" title="Instagram" target="_blank">
                                <span className="icon-link__icon-holder">
                                    <svg role="img" className="icon-link__icon">
                                        <use href="./img/sprite.svg#soc_ig"></use>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li className="social__item">
                            <a href={youtubeLink} className="social__link icon-link" title="YouTube" target="_blank">
                                <span className="icon-link__icon-holder">
                                    <svg role="img" className="icon-link__icon">
                                        <use href="./img/sprite.svg#soc_yt"></use>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li className="social__item">
                            <a href={facebookLink} className="social__link icon-link" title="Facebook" target="_blank">
                                <span className="icon-link__icon-holder">
                                    <svg role="img" className="icon-link__icon">
                                        <use href="./img/sprite.svg#soc_fb"></use>
                                    </svg>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="footer__links">
                    <h2 className="footer__title">
                        Useful Links
                    </h2>
                    <ul className="footer__list">
                        {primaryNavItems.map((item, index) => (
                            <li className="footer__list-item" key={index}>
                                <Link to={item.path} className="footer__link">{item.title}</Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="footer__cats">
                    <h2 className="footer__title">
                        Categories
                    </h2>
                    <ul className="footer__list">
                        {secondaryNavItems.map((item, index) => (
                            <li className="footer__list-item" key={index}>
                                <Link to={item.path} className="footer__link">{item.title}</Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="footer__contact">
                    <h2 className="footer__title">
                        Contact Us
                    </h2>
                    <a href={`mailto:${footerEmail}`} className="icon-link">
							<span className="icon-link__icon-holder">
								<svg role="img" className="icon-link__icon">
									<use href="./img/sprite.svg#mail"></use>
								</svg>
							</span>
                         {footerEmail}
                    </a>
                </div>
                <div className="footer__copy">
                    <EditableTextBlock definedName="footer-copyright" title="Footer copyright">
                        Copyright 2024. Slidy. All rights reserved.
                    </EditableTextBlock>
                </div>
            </div>
        </div>
    </footer>
}